import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import instagram from '../images/instagram.png';
import facebook from '../images/facebook.png';
import { FaTiktok } from 'react-icons/fa';
import logoIcon from '../images/logo.jpg';
import searchIcon from '../images/search.png';
import profileIcon from '../images/profile.png';
import cartIcon from '../images/cart.png';
import adminIcon from '../images/admin.png';
import { useTranslation } from "react-i18next";

export default function Header({cart}) {
    const [isOpen, setIsOpen] = useState(false);
    const { t, i18n } = useTranslation();
useEffect(() => {
  if (isOpen) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto'; 
  }
  return () => {
    document.body.style.overflow = 'auto';
  };
}, [isOpen]);
    return (
        <>
               <div className={`bMenu ${isOpen ? 'active' : ''}`}>
  <Link onClick={() => setIsOpen(!isOpen)} to="/">{t("header.swingSets")}</Link>
  <Link onClick={() => setIsOpen(!isOpen)} to="/kids-play" className='bMenu-sublink'>{t("header.kidsPlay")}</Link>
  <Link onClick={() => setIsOpen(!isOpen)} to="/family-play" className='bMenu-sublink'>{t("header.familyPlay")}</Link>
  <Link onClick={() => setIsOpen(!isOpen)} to="/shipping">{t("header.shipping")}</Link>
  <Link onClick={() => setIsOpen(!isOpen)} to="/contacts">{t("header.contacts")}</Link>
  {/* <Link onClick={() => setIsOpen(!isOpen)} to="/blogs">{t("header.blog")}</Link> */}
  <Link onClick={() => setIsOpen(!isOpen)} to="/installation">{t("header.installation")}</Link>
  <Link onClick={() => setIsOpen(!isOpen)} to="/about">{t("header.about")}</Link>
</div>
            <div className='container'>
                <header style={{position: 'relative'}}>
                    <div className='headerLeft'>
                        <a href='https://www.instagram.com/cedarkids.insta?igsh=Nmd0ZXVzMmg4d29v' target='_blank' rel='noopener noreferrer'><img src={instagram} alt='Instagram'/></a>
                        <a href='https://www.facebook.com/share/1Dgcgy1UUM/?mibextid=wwXIfr' target='_blank' rel='noopener noreferrer'><img src={facebook} alt='Facebook'/></a>
                        <a href='https://www.tiktok.com/@cedarkids.eu?_r=1&_t=ZS-9825Gwbxlpw' target='_blank' rel='noopener noreferrer'><FaTiktok size={20} color="#000000"/></a>
                    </div>
                    <div className='burgerMenu'>
                        <button
                            className={isOpen ? 'active' : ''}
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                        <a><img src={searchIcon} alt='none image'/></a>
                    </div>
                    <Link to="/" style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}><img style={{width: '100px'}} className='logo' src={logoIcon}
                                      alt='none image'></img></Link>
                    <div className='headerRight'>
                        {/* <Link to="/admin"><img src={adminIcon} alt='none logo'/></Link> */}
                        <Link to="/user"><img src={profileIcon} alt='none image'/></Link>
                        <Link to="/cart"><span>{cart.length}</span><img src={cartIcon} alt='none image'/></Link>
                    </div>
                </header>
               <div className='navigation'>
  <div className='nav-item nav-item--dropdown'>
    <Link to="/">{t("header.swingSets")}</Link>
    <ul className='nav-dropdown-menu'>
      <li><Link to="/kids-play">{t("header.kidsPlay")}</Link></li>
      <li><Link to="/family-play">{t("header.familyPlay")}</Link></li>
    </ul>
  </div>
  <Link to="/shipping">{t("header.shipping")}</Link>
  <Link to="/contacts">{t("header.contacts")}</Link>
  {/* <Link to="/blogs">{t("header.blog")}</Link> */}
  <Link to="/installation">{t("header.installation")}</Link>
  <Link to="/about">{t("header.about")}</Link>
</div>
            </div>
        </>
    )
}
